module.exports = __webpack_public_path__ + "img/VCC-logo.114a9943.svg";